module.exports = "<!-- <p>\n  message-notifications works!\n</p> -->\n"